import React from "react";
import FormattedMessageString from "../../../basics/FormattedMessageString";
import EventFormError from "../../errors/EventFormError";
import EventOptionGroup from "../../../../models/event/EventOptionGroup";

class OptionGroupTextFormComponent {
    static fields() {
        return [{
            type: "row",
            children: [
                {
                    type: "col",
                    md: 12,
                    fields: [{
                        title: "CMS.Event.option.group.form.title",
                        type: "text",
                        name: 'title',
                        customFeedback: EventFormError,
                        formErrorName: "title"
                    }]
                },
                {
                    type: "col",
                    md: 12,
                    fields: [{
                        title: "CMS.Event.option.group.form.description",
                        type: "textarea",
                        name: 'description',
                        optional: true,
                        customFeedback: EventFormError,
                        formErrorName: "description"
                    }]
                },
                {
                    type: "col",
                    md: 12,
                    fields: [{
                        title: "CMS.Event.option.group.form.type",
                        type: "select",
                        name: 'type',
                        options: [EventOptionGroup.TYPE_SINGLE, EventOptionGroup.TYPE_MULTIPLE].map(type => ({ value: type, label: <FormattedMessageString id={'CMS.Event.option.group.form.type.' + type} /> })),
                        customFeedback: EventFormError,
                        formErrorName: "type"
                    }]
                },
                {
                    type: "col",
                    md: 12,
                    fields: [{
                        title: "CMS.Event.option.group.form.required",
                        type: "switch",
                        name: 'required',
                        customFeedback: EventFormError,
                        formErrorName: "required"
                    }]
                }
            ]
        }];
    }
}

export default OptionGroupTextFormComponent;
